import { defineMessages, type MessageValue } from 'react-intl';

export const giftCardsScreenCategoriesNavMessages = defineMessages<{
  readonly categoryNavItemAccessibilityLabel: { readonly category: MessageValue };
}>({
  categoryNavItemAccessibilityLabel: {
    defaultMessage: 'Select "{category}" category',
    description: 'Gift Cards | Categories nav item accessibility label',
  },
});
